<app-modal-container>
  <span class="modal-header-content">
    {{ confirmationHeader }}
  </span>

  <div class="modal-body-content d-flex flex-column" [formGroup]="form">
    <p class="body-content-heading">
      {{ confirmationMessage }}
    </p>

    @if (confirmationDescription) {
      <span class="description">
        {{ confirmationDescription }}
      </span>
    }

    @if (isValidationNeeded) {
      <span class="margin-bottom-md">{{ 'required_fields_label' | translate }}</span>
      <app-common-input
        [context]="{ field: 'confirmation', label: confirmationLabel, placeholder: actionPlaceHolder }"
        [form]="form"
        [formValidationRequest$]="formValidationRequest"
      ></app-common-input>
    }
  </div>

  <div class="modal-footer-content">
    <div class="d-flex flex-wrap justify-content-between">
      <button ds-button [variant]="DsButtonVariants.secondary" (click)="close()">
        {{ confirmationLabelClose }}
      </button>
      <button ds-button data-test-id="modal-confirm-button" [intent]="confirmButtonIntent" (click)="onConfirm()">
        {{ confirmationLabelAction }}
      </button>
    </div>
  </div>
</app-modal-container>
